import React from "react";
import "./styles.scss";
import RegistrationForm from "../../registration/components/registration-form/registrationForm";
import SidePanel from "../../registration/components/side-panel/sidePanel";
import { Container, Row, Col } from "react-bootstrap";
import { UserRole } from "../../../shared/constants/Constant";

interface IProps {
  userRole: UserRole;
}

const Registration = (props: IProps) => {
  return (
    <Container fluid className="register-wrapper">
      <Row className="h-100">
        <Col className="d-none d-lg-flex p-0" xs={12} lg={4}>
          <SidePanel />
        </Col>
        <Col xs={12} lg={8} className="px-0">
          <RegistrationForm userRole={props.userRole} />
        </Col>
      </Row>
    </Container>
  );
};

export default Registration;
